import { compact, find, trimEnd } from "../../../shared/utils/lodash";
export default function buildHeadTitle(poiName, breadcrumbs) {
    var pipe = poiName ? "|" : "";
    var city = (find(breadcrumbs, { placeType: "city" }) || {}).title;
    var country = (find(breadcrumbs, { placeType: "country" }) || {}).title;
    var type = (find(breadcrumbs, { type: "poi" }) || {}).title;
    return trimEnd(compact([
        poiName,
        pipe,
        (city && country) ? city.concat(",") : city,
        country,
        type,
    ])
        .join(" "));
}



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/utils/buildHeadTitle.ts
// module id = tW0E
// module chunks = 2